import { instance2 } from "App/constants";
import { makeStyles } from "@material-ui/core/styles";
import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme";
import { MasterButton } from "App/Component/ui";
import { isNull, today } from "App/utils/helpers";
import React from "react";
import { startOfDay } from "utils/dates";

export const urlFilterInternal = "/patient/listpatientsfilter_regrj";
export const urlFilterBooking =
  "/registration/registration/verif_bookingfilter";
export const urlCancelBooking = "/registration/registration/cancelbooking";
export const urlUpdateBookingRekamMedis =
  "/registration/registration/updatebooking_rekammedis";

export const STATUS_APPROVE = 1;
export const STATUS_REJECT = 99;
export const STATUS_CANCEL_SIMRS = 1;

export const STYLE_VERIFIKASI_BOOKING = makeStyles({
  root: {
    width: "100%",
  },
  paper: {
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
    padding: "1rem 1.5rem",
  },
  table: {
    width: "97%",
    margin: "0 auto",
  },
});

export const RESET_STATE_VERIFIKASI_BOOKING = {
  status: 0,
  id_booking: "",
  id_booking_form: "",
  name: "",
  doctor_id: "",
  dates: today(),
  schedule_doctor_id: "",
  isVerifikasiUser: false,

  tanggal_antrian: "",
  no_antrian: "",
  rm_id: "",
  id_rm: "",
  nama_rm: "",
  jenis_kelamin: "",
  umur: "",
  phone_number: "",
  mobile_phone_number: "",
  address: "",
  place_ob: "",
  blood_type: "",
  gender: "",
  ethnic: "",
  isverified: false,

  pekerjaan: "",
  penanggung: "",
  nik: "",

  jenisrm: 2,

  name_booking: "",
  nik_booking: "",
  no_hp_booking: "",

  insurance_id: "",
  insurance_no: "",
  company_id: "",
  nokontrol: "",
  norujukan: "",

  userMobile: null,
};

export const getFilterVerifikasiBooking = async (formData, pages, limit) => {
  try {
    const scheduleAndDay = formData.schedule_doctor_id.split("--");
    const api = await instance2.get(
      "/registration/registration/verif_bookingfilter",
      {
        headers: {
          status: formData.status,
          id_booking: formData.id_booking,
          mobileonsite: formData.mobileonsite,
          id_dokter: isNull(formData.doctor_id) ? "" : formData.doctor_id,
          schedule_doctor_id: scheduleAndDay[0],
          name: formData.name,
          // dates: startOfDay(formData.dates),
          dates: formData.dates,
          user_mobile_verified: formData.user_mobile_verified ? 1 : 0,
          pages,
          limit,
        },
      }
    );
    const res = api.data;
    return {
      state: true,
      data: res.body,
      meta: res.meta,
    };
  } catch (error) {
    return {
      state: false,
      data: [],
      message: error?.response?.data?.message,
      meta: {
        count: 0,
      },
    };
  }
};

export const getByUserMobileID = async (id, norm) => {
  try {
    const api = await instance2.post("/mobile_registrasi/list-ktp", {
      id_pasien: id,
      status: 0,
      supno_rm: isNull(norm) ? "" : norm.toString(),
    });
    const response = api.data.body;
    if (response.length > 0) {
      return {
        state: true,
        data: response,
      };
    } else {
      return {
        state: false,
        data: [],
      };
    }
  } catch (error) {
    return {
      state: false,
      data: [],
    };
  }
};

export const RenderStatus = ({
  status,
  labelTrue = "Teverifikasi",
  labelFalse = "Belum Terverifikasi",
}) => {
  if (status === 1) {
    return (
      <MasterButton
        name={labelTrue}
        type='button'
        disabled={true}
        color='lightgreen'
      />
    );
  } else {
    return (
      <MasterButton
        name={labelFalse}
        type='button'
        disabled={true}
        color='danger'
      />
    );
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID BOOKING",
    align: "left",
    minWidth: "120px",
  },
  {
    id: "isverified",
    disablePadding: false,
    label: "IS VERIFIKASI",
    align: "center",
    minWidth: "170px",
  },

  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "status",
    disablePadding: false,
    label: "STATUS BOOKING",
    align: "center",
    minWidth: "150px",
  },
  {
    id: "rm_id",
    disablePadding: false,
    label: "ID RM",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "mobile_phone",
    disablePadding: false,
    label: "NO HP",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "phone_number",
    disablePadding: false,
    label: "TLP",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "nik",
    disablePadding: false,
    label: "NIK",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "nama_dokter",
    disablePadding: false,
    label: "DOKTER",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "schedule",
    disablePadding: false,
    label: "SCHEDULE",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "mobileonstie",
    disablePadding: false,
    label: "ASAL BOOKING",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "verif_remark",
    disablePadding: false,
    label: "ALASAN CANCEL",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];
